import { FC } from 'react';

import { BUSINESS_TYPE } from '@/api/types';
import CompaniesInputs from '@/features/v2/summaryForms/surveyTwo/Forms/CompaniesInputs';

import IndividualInputs from './Forms/IndividualInputs';
import JdgInputs from './Forms/JdgInputs';

interface Props {
  recipientType: BUSINESS_TYPE | null;
  isCoOwner?: boolean;
  prefix?: 'owner' | `coowners.${number}`;
  index?: number;
  defaultValues: {
    phone: string;
    email: string;
    first_name: string;
    last_name: string;
  };
}

export const PersonDataVehicleInputs: FC<Props> = ({
  recipientType,
  isCoOwner,
  prefix,
  index,
  defaultValues,
}) => {
  const componentMap = {
    [BUSINESS_TYPE.JDG]: JdgInputs,
    [BUSINESS_TYPE.ZOO]: CompaniesInputs,
    [BUSINESS_TYPE.SC]: CompaniesInputs,
    [BUSINESS_TYPE.SJ]: CompaniesInputs,
    [BUSINESS_TYPE.SA]: CompaniesInputs,
    [BUSINESS_TYPE.SK]: CompaniesInputs,
    [BUSINESS_TYPE.SKA]: CompaniesInputs,
  } as const;

  const SelectedComponent =
    (recipientType && componentMap[recipientType]) ?? IndividualInputs;

  return (
    <SelectedComponent
      isCoOwner={isCoOwner}
      prefix={prefix}
      index={index}
      recipientType={recipientType}
      defaultValues={defaultValues}
    />
  );
};
